/* Yum'Lube - Champ "Numéro de commande" obligatoire + validation sur le formulaire de contact */
(function () {
  function init() {
    var form = document.getElementById('ContactForm');
    if (!form || document.getElementById('ContactForm-order')) return;

    var div = document.createElement('div');
    div.className = 'field';
    div.style.flexWrap = 'wrap';

    var input = document.createElement('input');
    input.type = 'text';
    input.id = 'ContactForm-order';
    input.className = 'field__input';
    input.name = 'contact[Numéro de commande]';
    input.placeholder = 'Numéro de commande';
    input.required = true;
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('autocomplete', 'off');

    var label = document.createElement('label');
    label.className = 'field__label';
    label.htmlFor = 'ContactForm-order';
    label.appendChild(document.createTextNode('Numéro de commande '));
    var star = document.createElement('span');
    star.setAttribute('aria-hidden', 'true');
    star.textContent = '*';
    label.appendChild(star);

    div.appendChild(input);
    div.appendChild(label);

    var fields = form.querySelector('.contact__fields');
    if (fields && fields.parentNode) {
      fields.parentNode.insertBefore(div, fields.nextSibling);
    } else {
      form.insertBefore(div, form.firstChild);
    }

    var errorEl = null;
    function showError(msg) {
      if (!errorEl) {
        errorEl = document.createElement('small');
        errorEl.className = 'contact__field-error';
        errorEl.style.flex = '0 0 100%';
        errorEl.style.width = '100%';
        errorEl.style.display = 'block';
        errorEl.style.color = '#d72c0d';
        errorEl.style.marginTop = '0.5rem';
        div.appendChild(errorEl);
      }
      errorEl.textContent = msg;
      input.setAttribute('aria-invalid', 'true');
    }
    function clearError() {
      if (errorEl) errorEl.textContent = '';
      input.removeAttribute('aria-invalid');
    }

    form.addEventListener('submit', function (e) {
      var digits = (input.value || '').replace(/[^0-9]/g, '');
      if (digits.length < 3 || digits.length > 7) {
        e.preventDefault();
        e.stopPropagation();
        showError("Erreur : ce n'est pas le bon format.");
        try { input.focus(); } catch (x) {}
        return false;
      }
      input.value = '#' + digits;
      clearError();
    }, true);

    input.addEventListener('input', clearError);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
